import React from "react";

import { FormControl, Select, InputLabel } from "@material-ui/core";

export default function InputDropDowList({ label, value, onChangeValue, defaultValue, children, modeGrid, disabled, ...rest}) {

    return (
        <FormControl variant={ modeGrid?"":"outlined" } size="small" disabled={disabled?true:false} fullWidth>
            {modeGrid?"":<InputLabel shrink={true} id="demo-simple-outlined-label">{label}</InputLabel>}
            <Select
                {...rest}
                defaultValue={defaultValue}
                labelId="demo-simple-outlined-label"
                value={value}
                onChange={onChangeValue}>
                {children}
            </Select>
        </FormControl>
    )
}
